import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import Colors from '../common/Colors';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg viewBox='-9 -9 108 108' fill='none' color='inherit' xmlns='http://www.w3.org/2000/svg'>
    <rect width='90' height='90' rx='45' fill={Colors.grey[900]} fillOpacity='0.9' />
    <path
      d='M65.0678 43.3461C66.235 44.1398 66.235 45.8602 65.0678 46.6539L36.8746 65.825C35.5468 66.7279 33.75 65.7768 33.75 64.1711L33.75 25.8289C33.75 24.2232 35.5468 23.2721 36.8746 24.175L65.0678 43.3461Z'
      fill='currentColor'
    />
  </svg>,
  'PlayButton',
);

const ColoredIcon = styled(Icon)(({ theme, color = 'common.white' }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
